module.exports = __webpack_public_path__ + "img/Superb_sword_03.9a3a82d6.png";